import React, { useEffect } from 'react';
import { Box } from '@ublend-npm/aulaui-core';
import { useDispatch, useSelector } from 'react-redux';
import { fetchHomePosts } from '../../../../../actions/home/posts';
import InfiniteScroller from '../../../../containers/common/InfiniteScroller';
import { useTheme, useMediaQuery } from '@ublend-npm/aulaui-core';
import PostCell from '../../../ClassRoom/FeedV4/PostsTable/PostCell/PostCell';
import { Post } from '@app/types/core';

const RecentUpdates = () => {
  const dispatch = useDispatch();

  const { posts, postsLoading, postsHasMore } = useSelector(
    (state: any) => state.home || {}
  );

  const theme = useTheme();
  const isAboveMediumScreen = useMediaQuery(theme.breakpoints.up('md'));

  useEffect(() => {
    // Only fetch initially if empty and has more
    if (posts.length === 0 && postsHasMore && !postsLoading) {
      dispatch(fetchHomePosts() as any);
    }
  }, [dispatch, posts.length, postsHasMore, postsLoading]);

  const loadMorePosts = () => {
    dispatch(fetchHomePosts() as any);
  };

  return (
    <Box sx={{ mt: 2, flex: 1, display: 'flex', flexDirection: 'column' }}>
      <h2 style={{ marginBottom: '1rem', marginTop: 0 }}>Recent Updates</h2>
      <InfiniteScroller
        items={posts}
        loading={postsLoading}
        hasMore={postsHasMore}
        loadMore={loadMorePosts}
        orientation={isAboveMediumScreen ? 'vertical' : 'horizontal'}
        height={isAboveMediumScreen ? 600 : 250}
        renderItem={(item: Post | any) => (
          <div style={{ margin: '8px' }}>
            <PostCell key={item.objectId} post={item as Post} />
          </div>
        )}
      />
    </Box>
  );
};

export default RecentUpdates;
